import { Box, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

export const MissingClientCard = () => {
  return (
    <Box bg="gray.1" p="lg" style={{ borderRadius: '8px' }}>
      <Text size="md" fw={FONT_WEIGHTS.semibold} c="gray.10" mb="sm">
        Client details are missing
      </Text>

      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.7">
        We couldn&apos;t match the meeting attendee email addresses to any clients.
      </Text>
    </Box>
  );
};
